import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, withStyles } from '@material-ui/core';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});

const RemoteAssetsRemoveSession = props => {
    let { handleRemoveDevice, classes, deviceOnlineModalState, translations, handleCloseDanger } = props;

    const handleCloseSafe = () => {
        handleRemoveDevice();
    }

    return (
        <Dialog
            open={deviceOnlineModalState.onlineDeviceDialog}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{translations['remove_device'] || 'Remove device'} {deviceOnlineModalState.HardwareID}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {translations['carefully_remove_device'] || 'Be carefully when removing device.'}<br />
                    {translations['sure_want_remove'] || `Are you sure you want to remove this device`} ?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseSafe} variant="contained" className={classes.buttonSafe}>
                    {translations['no'] || 'No'}
                </Button>
                <Button onClick={handleCloseDanger} variant="contained" className={classes.buttonDanger}>
                    {translations['yes'] || 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles, { withTheme: true })(RemoteAssetsRemoveSession);